export default __webpack_public_path__ + "static/media/photo3.0b2d0516.jpg";